import React, { useEffect, useState, useContext } from 'react';
import { Box, LinearProgress, Card, Typography } from '@mui/joy';
import Alert from '@mui/material/Alert';
import { useDrawer, VehicleAvatar } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const formatDate = (dateString) => {
	const date = new Date(dateString);
	const months = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
	return months[date.getMonth()];
};

const KPICards = () => {
	const { activate } = useDrawer();
	const { userCapabilities } = useContext(AppContext);

	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	const dataProviderName = 'campaigns/campaign';
	const { items, loadAll, reloadCounter, errorMessage } = useDataProvider(dataProviderName);

	useEffect(() => {
		let canceled = false;

		const fetchCampaigns = async () => {
			console.log('[KPICards] fetchCampaigns start...');
			try {
				await loadAll();
				if (!canceled) setLoading(false);
				console.log('[KPICards] campaigns loaded:', items);
			} catch (err) {
				console.error('[KPICards] fetchCampaigns error:', err);
				if (!canceled) {
					setError(true);
					setLoading(false);
				}
			}
		};

		fetchCampaigns();

		return () => { canceled = true; };
	}, [reloadCounter]);

	console.log('[KPICards render] loading:', loading, 'error:', error, 'items:', items);

	if (loading && !error) return <LinearProgress />;
	if (error || (!items?.length && !loading)) return <Alert severity="info" variant="filled">Nessuna campagna assegnata o errore server</Alert>;

	return (
		<Box sx={{ p: 2 }}>
			<Typography level="h4" sx={{ mb: 3, fontWeight: 'bold' }}>Campagne assegnate</Typography>
			<Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(3, 1fr)' }, gap: 2 }}>
				{items.map(campaign => {
					console.log('[KPICards render] campaign:', campaign);
					const campaignId = campaign._id || campaign.id;
					return (
						<Card
							key={campaignId}
							variant="outlined"
							sx={{ p: 2, cursor: 'pointer', '&:hover': { boxShadow: 'md', borderColor: 'primary.500' } }}
							onClick={() => activate('campaignoperator/detail', { id: campaignId })}

						>
							<Box sx={{ display: 'flex', alignItems: 'center' }}>
								<Box sx={{ flex: 1 }}>
									<Typography level="title-lg" fontWeight="bold" sx={{ mb: 1 }}>{campaign.name}</Typography>
									<Typography level="h2" sx={{ mb: 1, fontWeight: 'bold' }}>{campaign.leads_count}</Typography>
									<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
										<Typography level="body-sm">{formatDate(campaign.start_at)} - {formatDate(campaign.end_at)} {new Date(campaign.start_at).getFullYear()}</Typography>
										<Typography level="body-sm" color="neutral">{campaign.mode}</Typography>
									</Box>
								</Box>
								<Box sx={{ width: 70, height: 70, borderRadius: '50%', bgcolor: 'primary.100', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, ml: 2, overflow: 'hidden' }}>
									<VehicleAvatar size="default" url={campaign.icon} item={campaign} />
								</Box>
							</Box>
						</Card>
					);
				})}
			</Box>
		</Box>
	);
};

export default KPICards;
